import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DataProtectionNoticeAcceptComponent } from './data-protection-notice-accept.component';
import { IntrackCoreModule } from '../../../core.module';
import { DataProtectionNoticeService } from './data-protection-notice.service';

@NgModule({
  declarations: [DataProtectionNoticeAcceptComponent],
  imports: [TranslateModule, IntrackCoreModule],
  providers: [DataProtectionNoticeService],
  exports: [DataProtectionNoticeAcceptComponent],
})
export class DataProtectionNoticeAcceptModule {}
